import { render, staticRenderFns } from "./CornerStats.vue?vue&type=template&id=44fb77d3&"
import script from "./CornerStats.vue?vue&type=script&lang=js&"
export * from "./CornerStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports